module.exports = __webpack_public_path__ + "img/project-2.04d53a96.jpg";